import React from 'react';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import './ToggleSwitch.scss';

const ToggleSwitch = ({
      checked = false,
      onChange,
      size = 'md', // 'sm', 'md', 'lg'
      label= '',  
      tooltip = null,
  }) => {
    return (
        <div className="toggle-switch-wrapper">
            <label className={`toggle-switch toggle-switch--${size}`}>
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                    className="toggle-switch__input"
                />
                <span className="toggle-switch__slider"></span>
            </label>
            {label && <span className="toggle-switch__label">{label}</span>}
            {tooltip && (
                <Tooltip title={tooltip} overlayStyle={{ maxWidth: 360 }}>
                    <InfoCircleOutlined className="toggle-switch__info" tabIndex={0} />
                </Tooltip>
            )}
        </div>
    );
};

export default ToggleSwitch;
